import { Common } from './common';
import { PatientWithAddress } from './models/patient';

interface RetrievePatientInformation {
  encounterId?: string;
  ehrInformationId?: string;
}

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }
  async findPatientInformation(
    args: RetrievePatientInformation,
  ): Promise<PatientWithAddress> {
    const url = this.common.constructPath('/patient-information', args);
    const {
      patientInformation,
      patientAddressMailing,
      patientAddressPhysical,
    } = await this.common.getJSON(url);
    return {
      patientInformation,
      patientAddressMailing,
      patientAddressPhysical,
    };
  }
}
